
import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

import DandDAPI from "@dndUtilities/system_api";

import FSIndex from "@dndComponents/FSIndex";
import AddButton from "@components/input/buttons/AddButton";

const api = DandDAPI.getInstance();

export default function GiftIndex() {
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  
  if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else {
    return (
      <FSIndex
        data_type="gift"
        quick_fields={["gift_type","tags"]}
        extra_by_add={api.user && api.user.admin ? () => {
          // debugger;
          return (
            <>
              &nbsp;
              <AddButton
                label="Parse Add"
                onClick={() => {
                  setNavigateTo(`/dandd/gift/parse_add`);
                }}
              />
              {/* &nbsp;
              <Button
                variant="contained" color="primary" 
                onClick={() => {
                  setOpen(true);
                }}>
                Spell Manager
              </Button> */}
            </>
          );
        } : undefined}
      />
    );
  }
}
